import React, { Component } from 'react';

import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
import { modules, formats } from './TextEditorToolbar';
import { Button } from 'semantic-ui-react';


export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            text: props.text,
            editMode: false
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentWillReceiveProps(newProps) {
        this.handleClose()
        if (this.props.text !== newProps.text) {
            this.setState({ name: newProps.name })
            this.setState({ text: newProps.text })
        }
    }

    removeClass() {
        this.setState({
            name: this.props.name,
            text: this.props.text,
        })
    }

    handleChange(value) {
        this.setState({ text: value })
    }
    handleOnFocus = () => {
        this.setState({ editMode: true })
    }
    handleOnBlur = () => {
        // this.setState({ editMode: false })
    }

    handleClose = () => {
        this.setState({ editMode: false })
        this.setState({
            name: this.props.name,
            text: this.props.text,
        })
    }

    saveClick = () => {
        this.props.onSaveClick(this.state)
        this.handleClose()
    }

    cancelClick = () => {
        this.handleClose()
    }

    render() {
        const { editMode } = this.state
        return (
            <div className="single-line-input-text">
                <label className="f_semiBold">{this.props.name}</label>
                {!editMode ?
                    <ReactQuill
                        value={this.state.text ? this.state.text : ""}
                        key={this.state.name}
                        theme="bubble"
                        onFocus={this.handleOnFocus}
                        modules={modules}
                        formats={formats}
                        bounds={'.single-line-input-text'}
                    />
                    :
                    <React.Fragment>
                        <ReactQuill
                            value={this.state.text ? this.state.text : ""}
                            key={this.state.name}
                            onChange={this.handleChange}
                            onBlur={this.handleOnBlur}
                            onKeyDown={this.handleKeyPress}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            bounds={'.single-line-input-text'}
                        />
                        <div className="actionMultilineBtn">
                            <Button
                                type="button"
                                icon="cancel"
                                className="button-cancel pad_5"
                                onClick={this.cancelClick}
                            />
                            <Button
                                type="submit"
                                icon="check"
                                className="button-submit pad_5"
                                onClick={this.saveClick}
                            />
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}
